module.exports = __webpack_public_path__ + "static/media/icon_calendar_nav_right.35c9b697.svg";